require('./style.less');

var SideHeader = require('../sidePanelHeader');
var AjaxSpinner = require('./ajaxIndicator');
var OverflowMenu = require('./overflowMenu/headerOverflow');
var BabySitterView = require('../../../common/BabySitterView'); /* holds the overflow menu and ajax spinner */
var NewNoteDD = require('../../../notes/views/header/createNew/newNoteMenu');

/**
 *
 * Collection: the allNotes Collection -- could change and make clearer now.
 */

module.exports = SideHeader.extend({

    template: require('./headerRight.hbs'),
    className: 'FV-header-right',
    onRender: Backbone.View.prototype.unwrap,
    initialize: function(options) {

        this.collection = options.collection;

        BabySitterView.prototype.createChildren.call(this);

        //TODO: -- mediate vChannel / lChannel (see below) : capture on mod subscriptions
        _.extend(this, Backbone.Radio.Channel.prototype);

        this.comply({
            toggleFullScreen: function(isFullScreen) {
                this.children.findByCustom('overflow').triggerMethod('toggleFullScreen', isFullScreen);
            },
            stopAjaxSpinner: function() {
                this.children.findByCustom('ajaxSpinner').triggerMethod('stop');
            }
        });

        this.reply({
           overflowMenu: function() {
               return this.children.findByCustom('overflow');
           }
        });

        var lCh = this.options.lChannel;
        this.listenTo(lCh, 'updateNoteCount', this.updateNoteCount);
        this.listenTo(lCh, 'updateFullTextSearchCount', this.updateFullTextSearchCount);
        this.listenTo(lCh, 'rightHeader:toggleNewNoteMenu', this.toggleNewNoteMenu);

        /* Note: switch from collectionEvents to fix context issue on callback */
        SideHeader.prototype.initialize.call(this, options);  //fine, the base has init

    },
    serializeData: function() {

        var fullTextQuery = this.options.fullTextQuery,
            numberNotes = this.collection.length,
            showFullTextButton = fullTextQuery !== null,
            numFTHits = showFullTextButton ? this.options.numberFTHits : 0; //TODO: get nmFThits from the fullTextQuery Mod (now on active doc)

        return {
            numberNotes: numberNotes,
            notesTitle: this._getNotesTabTitle(numberNotes),
            showFullTextButton: showFullTextButton,
            numFTHits: numFTHits,
            //note: i think fullTextSearchTitle maybe unnecessary: this will update anyway post search completion -- notes WF doesn't work this way
            fullTextSearchTitle: showFullTextButton ? this._getFullTextSearchIconTitle(numFTHits, fullTextQuery) : '',
            hideNoteCount: numberNotes < 1,
            hideFTCount: numFTHits < 1
        };

    },
    ui: {
        numberNotes:        '.numberNotes',
        noteTabWr:          '.FV-nav-notes',
        numberFTSearchHits: '#ftHits',
        ajaxSpinner:        '.spinner-ajax-wr',
        overflowMenu:       '#more',
        newNoteDD:          '.add-pg-note',
        notesTab:           '#notesTab',
        fullTextTab:        '#fullTextBtn'
    },
    onBeforeShow: function() {

        var vCh = this.options.lChannel.request('vChannel');

        this.children
            .add(new AjaxSpinner({
                el: this.ui.ajaxSpinner
            }).render(), 'ajaxSpinner')
            .add( new OverflowMenu({
                el: this.ui.overflowMenu,
                vChannel: vCh,
                ddOptions: _.extend({
                    hPos: 'right',
                    ddNoSelect: true // allow event but closes the dropdown
                }, { container: vCh.request('getWrapper') })
            }).render(), 'overflow');

    },
    togglePanelBtnClicked: function(e) {

        // Don't allow to switch off note subPane if currently editing the note
        if ( this.options.lChannel.request('activeNote'))
            return false;

        SideHeader.prototype.togglePanelBtnClicked.call(this, e);

    },
    updateNoteCount: function(num) {

        this.ui.notesTab
            .toggleClass('hide-badge', num < 1)
            .attr( 'title', this._getNotesTabTitle(num) );

        this.ui.numberNotes.text( num );

    },
    _getNotesTabTitle: function(numberNotes) {

        var t = 'Notes';
        (numberNotes > 0) && ( t += ' (' + numberNotes + ')' );
        return t;

    },
    // localSearchTxt will exist if es module in 'local grep mode'
    updateFullTextSearchCount: function(numHits, searchTxt, localSearchTxt) {

        this.ui.fullTextTab
            .toggleClass('hide-badge', numHits < 1)
            .attr('title', this._getFullTextSearchIconTitle.apply(this, arguments) );

        this.ui.numberFTSearchHits.text(numHits);

    },
    /* called on update and initial render -- for now initial would never have localSearchTxt -- not an option */
    _getFullTextSearchIconTitle: function(numHits, searchTxt, localSearchTxt) {

        if (searchTxt === '')
            return 'Blank Search';

        var title = 'Search: "' + searchTxt + '" (' + (numHits < 1 ? 'No' : numHits) + ' results)';
        localSearchTxt && (title += '\n' + 'Filtered by: "' + localSearchTxt + '"');

        return title;

    },
    onCreateNewNoteMenu: function(ddContent, notesChannel, ddContainer) {

        var noteMenu = new NewNoteDD({
            el: this.ui.newNoteDD,
            channel: notesChannel,
            isFromViewerHeader: true,
            ddOptions: {
                container: ddContainer,
                $content: ddContent,  // utilize the already existing content from the other dropdown
                hPos: 'right',
                ddNoSelect: true,
                activeClass: 'active',
                onChange: function() {
                    NewNoteDD.prototype.onChange.apply(noteMenu, arguments);
                }
            }
        }).render();

        this.children.add(noteMenu, 'noteMenu');

    },
    toggleNewNoteMenu: function(hideIt) {
        this.ui.newNoteDD.toggleClass( 'hide', hideIt );
    },
    onBeforeDestroy: function() {

        this.reset();
        BabySitterView.prototype.onBeforeDestroy.call(this); //TODO: recursion -- b/c use as constructor
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerRight/headerRight.js
 ** module id = 735
 ** module chunks = 0
 **/